import { defineStore } from "pinia";
import { useGet, usePatch, usePost } from "~/composables/useApi";
import { ClientTypeEnum } from "~~/enums/clientTypeEnum";

export const useAuthStore = defineStore("auth", {
	state: () => {
		return { 
			data: {
				document: "",
				// LOGIN
				password: "",
				// REGISTRY
				name: "",
				firstname: "",
				 lastname: "",
				email: "",
				phone: "",
				birthday: null,
				rg: null,
				gender: null,
				// ADDRESS
				postcode: null, 
				state: null, 
				city: null,
				district: null, 
				address: null,
				number: null,
				acceptTerm: false,
				custom_data: {},
				is_new_password_required: false,
				type: ""
			},
			completedAddress: false as boolean,
			access_token: null, 
			document: null as any, 
			is_authenticated: false,
			is_admin: false,
			is_attendant: false,
			is_client: false,
			redirect: null,
		};
	},
	actions: {
		async login(document: string, password: string) {
			const user = useCookie<{ access_token: string, is_authenticated: boolean }>('user')
		
			const { access_token } = await usePost("/auth/login", { document, password });
			this.access_token = access_token;
			this.document = document;
			this.is_authenticated = true;			
			user.value = { access_token: access_token, is_authenticated: true };
		},
		async register_new_password(password: string, document: string) {		
			const { success } = await usePatch("/client/register_new_password", { is_new_password_required: true, password,document });
			return success;
		},
		async token_login(token: string) {
			const user = useCookie<{ access_token: string, is_authenticated: boolean }>('user')
			const { access_token } = await usePost("/auth/token/login", {}, {
				"Authorization": `Bearer ${token}`,
			});
			this.access_token = access_token;
			this.is_authenticated = true;
			const { document } = await this.me();
			this.document = document;
			user.value = { access_token: access_token, is_authenticated: true };
		},
		async request_password(document: string) {
			return usePost("/client/reset/password", { document });
		},
		async reset_password(token: string, password: string) {
			return usePatch("/client/reset/password", {
				token,
				password,
			});
		},
		clear() {
			this.access_token = null;
			this.is_authenticated = false;
			const userCookie = useCookie('user');
			userCookie.value = null;
			this.completedAddress = false;
			this.data = {
				document: "",
				password: "",
				name: "",
				firstname: "",
				lastname: "",
				email: "",
				phone: "",
				rg: null,
				gender: null,
				birthday: null,
				postcode: null,
				state: null,
				city: null,
				district: null,
				address: null,
				number: null,
				acceptTerm: false,
				custom_data: {},
				type: ""
			};
			this.is_admin = false;
			this.is_attendant = false;
			this.is_client = false;
		},
		async me() {
			this.data = await useGet("/client/me");
			if(this.data.type === ClientTypeEnum.ADMIN) {
				this.is_admin = true;
			}
			if(this.data.type === ClientTypeEnum.ATTENDANT) {
				this.is_attendant = true;
			}
			if(this.data.type === ClientTypeEnum.CLIENT) {
				this.is_client = true;
			}
			return this.data;

		},
		isAuthenticated() {
			return this.is_authenticated;
		},
		isAdmin() {
			return this.is_admin;
		},
		isAttendant() {
			return this.is_attendant;
		},
		isClient() {
			return this.is_client;
		},
		getHeader() {
			if (this.isAuthenticated()) return {
				"Authorization": `Bearer ${this.access_token}`,
			};
			return {};
		},
	},
	persist: true,
});
